


































import { Vue, Component } from 'vue-property-decorator';
import Modal from '@/components/widgets/molecules/Modal/Modal.vue';
import Table from '@/components/widgets/organisms/Table/Table.vue';
import ButtonCustom from '@/components/widgets/atoms/ButtonCustom/ButtonCustom.vue';

import {
	SELECT_INTEGRATION_SUCCESS,
	SELECT_TRANSIT_TRAVEL_DETAIL,
} from '@/store/TransitFacility/travels/actions';

@Component({
	components: {
		Modal,
		Table,
		ButtonCustom,
	},
})
export default class IntegrationOutSuccess extends Vue {
	/* Data */
	private isLoading: boolean = false;

	private pedido: string = '';

	private idOutsystem: string = '';

	/* Computed */
	get showModal() {
		return this.$store.getters.hasSelectedIntegrationOutSuccess;
	}

	get selectedIntegrationSuccess() {
		return this.$store.getters.getSelectedIntegrationOutSuccess;
	}

	/* Methods */
	resetInfo() {
		this.$store.dispatch(SELECT_INTEGRATION_SUCCESS, null);
	}

	initInfo() {
		this.isLoading = true;

		this.pedido = this.selectedIntegrationSuccess.viagem || this.selectedIntegrationSuccess.pedido || '';
		const messageReturnOutsystem =
			this.selectedIntegrationSuccess.mensagemIntegracaoOutsystem || '';

		this.idOutsystem = messageReturnOutsystem.replace(/\D/g, '');

		this.isLoading = false;
	}

	closeModalError() {
		this.close();
	}

	openEdit() {
		this.$store.dispatch(SELECT_TRANSIT_TRAVEL_DETAIL, this.selectedIntegrationSuccess.viagem);
		this.close();
	}

	close() {
		this.$bvModal.hide('IntegrationOutSuccess');
	}
}
